import { useState, useEffect, useCallback } from "react";

import Sidebar from "../components/Sidebar/Sidebar";
import Topbar from "../components/Topbar/Topbar";
import { resolveNavigationTitle } from "../components/Sidebar/navigationTitles";
import { useAuth } from "../context/AuthContext";
import { useLocation } from "react-router-dom";
import "./dashboardlayout.css"
function DashboardLayout({ children, noPadding = false }) {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const { user, updateUser,getMe } = useAuth();
    const { pathname } = useLocation();

    useEffect(() => {
        // Poll every 15 minutes
        const intervalId = setInterval(getMe, 900000);
        // Fetch on window focus
        window.addEventListener('focus', getMe);

        return () => {
            clearInterval(intervalId);
            window.removeEventListener('focus', getMe);
        };
    }, [getMe]);
    return (
        <div className="main-div-dash">
            <Sidebar
                isOpen={sidebarOpen}
                setIsOpen={setSidebarOpen}
                onClose={() => setSidebarOpen(false)}
                onMenuClick={() => setSidebarOpen(!sidebarOpen)}
            />
            {sidebarOpen && (
                <div
                    className="secondary-div-dash"
                    onClick={() => setSidebarOpen(false)}
                />
            )}
            <div className="third-div-dash">
                <Topbar
                    title={resolveNavigationTitle({ pathname, role: user?.role })}
                    onMenuClick={() => setSidebarOpen(true)}
                />
                <main className={`main-dash ${noPadding ? '!p-0 !overflow-hidden' : ''}`}>
                    {children}
                </main>
            </div>
        </div>
    );
}

export default DashboardLayout;
